import React from 'react';
import logomuseu from "../../assets/logomuseu.png";
import '../../scss/admin/footer.scss';

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (props) => {
    return (
        <>
            <div className='footer container'>
                <footer className="row row-cols-1 row-cols-sm-2 row-cols-md-5 py-5 my-5 border-top">
                    <div className="col mb-3">
                        <a href="/" className="d-flex align-items-center mb-3 link-dark text-decoration-none">
                            <img width="120" height="150" src={logomuseu} alt="bootstrap" />
                        </a>
                        <p className="text-muted">© {new Date().getFullYear()}</p>
                    </div>

                    <div className="col mb-3">
                        <h5>Acervo do Centro de Memória e Museu Histórico da FMRP/USP</h5>
                    </div>

                    <div className="col mb-3">
                        <h5>Acessos</h5>
                        <ul className="nav flex-column">
                            <li className="nav-item mb-2"><a href="/" className="nav-link p-0 text-muted">Página inicial</a></li>
                            <li className="nav-item mb-2"><a href="/acervo" className="nav-link p-0 text-muted">Acervo</a></li>
                            <li className="nav-item mb-2"><a href="/creditos" className="nav-link p-0 text-muted">Sobre</a></li>
                        </ul>
                    </div>

                    <div className="col mb-3">
                        <h5>Administração</h5>
                        <ul className="nav flex-column">
                            <li className="nav-item mb-2"><a href="/login" className="nav-link p-0 text-muted">Login</a></li>
                           {/* <li className="nav-item mb-2"><a href="#" className="nav-link p-0 text-muted">Documentação</a></li>*/} </ul> 
                    </div>

                </footer>
            </div>
        </>
    )
};